module.exports = "<p>\n  page-not-found-component works!\n</p>\n"